<script>
  import { format } from 'svelte-i18n';
  import { Col, Row } from '@sveltestrap/sveltestrap';

  import { Select } from '@client/components/select';

  /**
   * @typedef {Object} ImageAsset
   * @property {string} [imageurl] - URL of the image.
   * @property {Object} [metadata] - Metadata of the image.
   * @property {Object} [metadata.imageinfo] - Image information.
   * @property {number} [metadata.imageinfo.width] - Width of the image.
   * @property {number} [metadata.imageinfo.height] - Height of the image.
   */

  /**
   * Assets to choose an image from.
   * @type {ImageAsset[]}
   */
  export let images = [];

  /**
   * The URL of an image, if one is provided directly.
   * @type {string | undefined}
   */
  export let value;

  /**
   * Generates a string representing the dimensions of an image.
   * @param {ImageAsset} image - The image asset.
   * @returns {string} A string in the format "width x height" or an empty string if dimensions are not available.
   */
  const dimensions = (image) => `${image?.metadata?.imageinfo?.width}x${image?.metadata?.imageinfo?.height}`;

  $: selectedImage = images.find((image) => image.imageurl === value);
</script>

<Select
  id="logo-assets"
  {...$$restProps}
  items={images}
  itemId="imageurl"
  class="select-element"
  placeholder={$format('label.ASSET_SELECT_PLACEHOLDER')}
  clearable={false}
  label="filename"
  showChevron
  value={selectedImage}
  on:change={(e) => {
    const url = e.detail?.imageurl;
    if (url) value = url;
  }}
>
  <svelte:fragment slot="selection" let:selection let:index>
    <span data-testid="selected-item" class="selection">
      {selection.filename}
    </span>
  </svelte:fragment>
  <svelte:fragment slot="item" let:item>
    <div class="item">
      <Row>
        <Col xs={3} class="text-center">
          <div class="preview">
            <img src={item.imageurl} alt={item.filename} loading="lazy" />
          </div>
        </Col>
        <Col class="text-truncate">
          <div>
            {item.filename}
          </div>
          <small class="dimensions">
            {dimensions(item)}
          </small>
        </Col>
      </Row>
    </div>
  </svelte:fragment>
</Select>

<style lang="scss" src="./asset-select.scss"></style>
